<!--
 * @Description:
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2024-07-25 11:33:26
 * @LastEditTime: 2024-07-26 11:33:57
-->
<template>
<div class="fire-fac">
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <el-input placeholder="场所名称" v-model="placeName"></el-input>
      <button v-if="rolePermit('role:query')" class="primaryBtn" @click="search">搜索</button>
      <button v-if="rolePermit('role:add')" class="primaryBtn" @click="handleAdd">新增</button>
    </div>
    <div class="tableBox contentShowArea">
      <border-table :loading="tableLoading" :tableData="dataList"  :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleCurrentChange" @sizeChange="handleSizeChange">
        <el-table-column prop="firstTag" label="一级标签"/>
        <el-table-column prop="secondTag" label="二级标签"/>
        <el-table-column prop="thirdTag" label="三级标签"/>
        <el-table-column prop="placeName" label="场所名称"/>
        <el-table-column prop="createTime" label="创建时间" sortable="custom" />
        <el-table-column fixed="right" label="操作" width="220">
          <template #default="{row}">
             <el-button class="editBtn" type="text" icon="el-icon-edit-outline" @click="handleEditClick(row)" >编辑</el-button> 
            <el-button class="delBtn" type="text" icon="el-icon-delete" @click="handleDeleteClick(row)">删除</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>

  <el-drawer title="设置场所" size="600px" :visible.sync="isShow" @close="handleClose">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="form" :model="formData" :rules="formRules" label-width="120px">
          <el-form-item label="一级标签" prop="tag1">
            <el-select v-model="formData.tag1" placeholder="请选择一级标签">
              <el-option label="消防安全" value="01" />
            </el-select>
          </el-form-item>
          <el-form-item label="二级标签" prop="tag2">
            <el-select v-model="formData.tag2" placeholder="请选择二级标签" @change="handleChange($event, 'tag2')">
              <el-option
                v-for="item in options"
                :key="item.secondVar"
                :label="item.secondTag"
                :value="item.secondVar" />
            </el-select>
          </el-form-item>
          <el-form-item label="三级标签" prop="inRelation">
            <el-select v-model="formData.inRelation" placeholder="请选择三级标签" @change="handleChange">
              <el-option
                v-for="item in options3"
                :key="item.inRelation"
                :label="item.thirdTag"
                :value="item.inRelation" />
            </el-select>
          </el-form-item>
          <el-form-item label="场所名称" prop="placeName">
            <el-input v-model.trim="formData.placeName" type="text" :maxlength="30" placeholder="请输入场所名称"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawerFoot">
        <el-button type="primary" @click="handleSave" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
        <el-button @click="isShow = false">取 消</el-button>
      </div>
    </div>

  </el-drawer>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable.vue";
import OneGroupCheckboxs from "@/components/common/OneGroupCheckboxs";
import {
  log
} from 'util';
export default {
  components: {
    BorderTable,
    OneGroupCheckboxs
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableHeight: null,
      tableLoading: false,
      dataList: [],
      placeName: '',
      isShow: false,
      loading: false,
      formData: {
        tag1: '',
        tag2: '',
        inRelation: '',
        placeName: ''
      },
      formRules: {
        tag1: [{ required: true, message: "一级标签不能为空", trigger: "blur" }],
        tag2: [{ required: true, message: "二级标签不能为空", trigger: "blur" }],
        inRelation: [{ required: true, message: "三级标签不能为空", trigger: "blur" }],
        placeName: [{ required: true, message: "场所名不能为空", trigger: "blur" }]
      },
      options: [],
      options3: [],
    };
  },
  computed: {
    currentTreeId() {
      return this.$store.state.currentTreeId;
    },
    screenData() {
      return this.$store.state.screen;
    }
  },
  watch: {
    currentTreeId() {
      this.queryForm.orgId = this.currentTreeId;
      this.querydataList();
    },
    screenData() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    }
  },
  created() {
    this.makeheight()
    this.getOptionsData('01', 'options')
  },
  mounted() {
    this.querydataList()
  },
  methods: {
    async getOptionsData (tag, key) {
      let { code, data, msg } = await this.request.get(`/front/system/placeType/queryByVar?var=${tag}`)
      if (code != 200) return this.msg.error(msg)

      this[key] = data
    },
    search() {
      this.pagination.currentPage = 1;
      this.querydataList();
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    async querydataList() {
      this.tableLoading = true;
      let { placeName } = this
      let { currentPage, pageSize } = this.pagination

      let { code, data, msg } = await this.request.post("/front/system/placeTypeTenant/query", {
        placeName,
        page: currentPage,
        pageSize
      })
      this.tableLoading = false
      if (code != 200) return this.msg.error(resp.msg)

      this.dataList = data.data
      this.pagination.total = data.totalCount
    },
    handleChange (e, tag) {
      if (tag == 'tag2') {
        this.formData.inRelation = ''
        this.getOptionsData(e, 'options3')
      }
    },
    handleAdd() {
      this.isShow = true;
    },
    handleClose() {
      this.isShow = false
      this.$refs["form"].resetFields()
      this.formData = {
        tag1: '',
        tag2: '',
        inRelation: '',
        placeName: ''
      }
    },
    handleSave() {
      this.$refs["form"].validate(async valid => {
        if (!valid) return this.msg.error("请按要求完善表单信息")

        let { inRelation, placeName, id } = this.formData

        let url = id ? '/front/system/placeTypeTenant/update' : '/front/system/placeTypeTenant/save'

        this.loading = true
        let { code, data, msg } = await this.request.post(url, { inRelation, placeName, id })
        this.loading = false
        if (code != 200) return this.msg.error(msg)

        this.msg.success("操作成功")
        this.handleClose()
        this.pagination.currentPage = 1
        this.querydataList()
      })
    },
    handleEditClick(row) {
      let { firstVar, secondVar, thirdVar } = row
      this.formData = {
        ...row,
        tag1: firstVar,
        tag2: secondVar,
        inRelation: thirdVar
      }
      this.isShow = true
      this.getOptionsData(secondVar, 'options3')
    },
    handleDeleteClick({ id }) {
      this.$confirm("确定要进行删除操作吗？", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let { code, msg } = await this.request.delete(`/front/system/placeTypeTenant/${id}`)
        this.loading = false
        if (code != 200) return this.msg.error(msg)

        this.msg.success('删除成功')
        this.querydataList()
      }).catch(() => {
        this.msg.info('已取消删除')
      });
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.querydataList();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.querydataList();
    },
  }
};
</script>

<style lang="scss" scoped>
.fire-fac {
  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .query {
      padding: 0 20px 20px;
    }

    .tableBox {
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.fire-fac {
  .drawerWrap .el-form .el-form-item__content .el-checkbox{
    
  }
  .mainContent {
    .query {
      .el-input {
        width: 200px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }

  }

  .formBox {
    .el-form-item {
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }

  }

  .contentShowArea {
    // position: absolute;
    // top: 36px;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // padding: 10px;

    // .el-table__header-wrapper {
    //   tr {
    //     background: #f8f8f8;

    //     th {
    //       background: #f8f8f8;
    //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
    //       color: #333333;
    //       padding: 10px 0;

    //       .cell {
    //         // font-weight: bold;
    //         font-family: PingFangBold;

    //         .caret-wrapper {
    //           height: 29px;

    //           .ascending {
    //             top: 3px;
    //           }

    //           .descending {
    //             bottom: 5px;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }

    // .el-table__body-wrapper {
    //   tbody {
    //     tr {
    //       td {
    //         border: none;
    //         padding: 9px 0;

    //         .cell {
    //           color: #333;
    //         }
    //       }
    //     }
    //   }
    // }

    .el-table__fixed-right {
      &::before {
        display: none;
      }

      // .el-table__fixed-header-wrapper {
      //   tr {
      //     background: #f8f8f8;

      //     th {
      //       background: #f8f8f8;
      //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
      //       color: #333333;
      //       padding: 10px 0;

      //       .cell {
      //         // font-weight: bold;
      //         font-family: PingFangBold;

      //         .caret-wrapper {
      //           height: 29px;

      //           .ascending {
      //             top: 3px;
      //           }

      //           .descending {
      //             bottom: 5px;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }

      .el-table__fixed-body-wrapper {
        tbody {
          tr {
            td {
              // border: none;
              // padding: 9px 0;

              .cell {
                text-align: center;

                .editBtn {
                  color: #28c6a2;
                }

                .delBtn {
                  color: #dd3071;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
